import { DateTime } from 'luxon';

const headers = [
  { label: 'Response Code', key: 'responseCodeClassifier' },
  {
    label: 'Date',
    key: 'processingDate',
    getValue: (transaction) => {
      return DateTime.fromISO(transaction.transactionDate).toFormat('yyyy/MM/dd');
    },
  },
  {
    label: 'Time',
    key: 'time',
    getValue: (transaction) => {
      return DateTime.fromISO(transaction.transactionDate).toFormat('HH:mm');
    },
  },
  { label: 'Amount', key: 'transactionAmount' },
  { label: 'Transaction Type', key: 'transactionTypeDescription' },
  { label: 'Reference Number', key: 'retrievalReferenceNumber' },
  { label: 'Transaction Description', key: 'transactionDescription' },
];

const terminalHeaders = [
  { label: 'Response Code', key: 'responseCodeClassifier' },
  { label: 'Response Code Description', key: 'responseCodeDescription' },
  {
    label: 'Date',
    key: 'processingDate',
    getValue: (transaction) => {
      return DateTime.fromISO(transaction.transactionDate).toFormat('yyyy/MM/dd');
    },
  },
  {
    label: 'Time',
    key: 'time',
    getValue: (transaction) => {
      return DateTime.fromISO(transaction.transactionDate).toFormat('HH:mm');
    },
  },
  { label: 'Amount', key: 'transactionAmount' },
  { label: 'Transaction Type', key: 'transactionTypeDescription' },
  { label: 'Transaction Description', key: 'transactionDescription' },
  { label: 'Retrieval Reference', key: 'retrievalReferenceNumber' },
  { label: 'Terminal ID', key: 'terminalId' },
  { label: 'Payment Type', key: 'methodOfPayment' },
  { label: 'Coupon Provider', key: 'receivingInstitutionName' },
  { label: 'Card Present', key: 'cardPresent' },
  { label: 'PAN', key: 'PAN' },
  { label: 'Cashback', key: 'cashbackAmount' },
  { label: 'Tip Amount', key: 'tipAmount' },
  { label: 'Retrieval Reference', key: 'extendedRetrievalReferenceNumber' },
];

export function transformTransactionsForCsv(
  merchantName,
  selectedDates,
  transactions,
  isTerminalTransaction,
) {
  const fromDate = DateTime.fromJSDate(selectedDates[0]);
  const toDate = DateTime.fromJSDate(selectedDates[1]);
  const fromDateStr = fromDate.toFormat('yyyy/MM/dd');
  const toDateStr = toDate.toFormat('yyyy/MM/dd');
  const notice =
    'Please note that some transactions which have not yet been settled may have fees and/or other charges applied later.';

  let headerString = '';
  let transactionString = ``;

  if (isTerminalTransaction) {
    headerString = `${merchantName}\n\nDate: ${fromDateStr};;Date Range:  ${fromDateStr} - ${toDateStr}\n\n${notice}\n\n${terminalHeaders
      .map((header) => header.label)
      .join(';')}\n`;
    transactionString += transactions
      .map((transaction) =>
        terminalHeaders
          .map((header) =>
            !!header.getValue ? header.getValue(transaction) : transaction[header.key],
          )
          .join(';'),
      )
      .join('\n');
  } else {
    headerString = `${merchantName}\n\nDate: ${fromDateStr};;Date Range:  ${fromDateStr} - ${toDateStr}\n\n${notice}\n\n${headers
      .map((header) => header.label)
      .join(';')}\n`;
    transactionString += transactions
      .map((transaction) =>
        headers
          .map((header) =>
            !!header.getValue ? header.getValue(transaction) : transaction[header.key],
          )
          .join(';'),
      )
      .join('\n');
  }

  return {
    fileName: `${merchantName} transactions ${fromDateStr} - ${toDateStr}.csv`,
    csvString: headerString + transactionString,
  };
}
